
{
  "fr": {
    "configuratorLayerEditorModalToolbarColorPickerItem": {
      "label": "Sélectionner une couleur",
      "title": "@:configuratorLayerEditorModalToolbarColorPickerItem.label"
    }
  }
}
